import { Pipe, PipeTransform } from '@angular/core';
import { SecurityFacade } from '@core/ngrx/facades/security.facade';
import { map, Observable } from 'rxjs';

@Pipe({
  name: 'hasPermission'
})
export class HasPermissionPipe implements PipeTransform {
  constructor(private securityFacade: SecurityFacade) {}

  transform(permissions: string | string[]): Observable<boolean> {
    const permsArray = Array.isArray(permissions) ? permissions : [permissions];
    return this.securityFacade.userAccess$.pipe(
      map(({ permissions: userPerms }) =>
        permsArray.some(p => userPerms.includes(p))
      )
    );
  }
}
